import { z } from '@hono/zod-openapi'
import { zSelectDomain } from './domains.zod'

export const zCreateBulkDomains = z.object({
    clientId: z.string({ message: 'ClientId is required' }),
    domains: z.string().array().min(1, {
        message: 'At least one domain is required',
    }),
})

export const zDomainBulkCreateSuccessResponse = z.array(zSelectDomain)

export const zDomainBulkCreateConflictResponse = z.object({
    existingDomains: z.string().array().optional(),
})

export type CreateBulkDomains = z.infer<typeof zCreateBulkDomains>
